export default __webpack_public_path__ + "static/FaceSwap-98623793be7211d6aab942888492e02e.mp4";